import { FormElement } from "../types";
import { TextInput } from "./TextInput";
import { ChoiceInput } from "./ChoiceInput";
import { SwitchInput } from "./SwitchInput";
import { DateInput } from "./DateInput";
import { TextareaInput } from "./TextareaInput";

interface FormElementRendererProps {
  element: FormElement;
  value: string;
  onChange: (value: string) => void;
}

export const FormElementRenderer = ({ element, value, onChange }: FormElementRendererProps) => {
  switch (element.type) {
    case "text":
    case "email":
      return <TextInput element={element} value={value} onChange={onChange} />;
    case "choice":
      return <ChoiceInput element={element} value={value} onChange={onChange} />;
    case "switch":
      return <SwitchInput element={element} value={value} onChange={onChange} />;
    case "date":
      return <DateInput element={element} value={value} onChange={onChange} />;
    case "textarea":
      return <TextareaInput element={element} value={value} onChange={onChange} />;
    default:
      return null;
  }
};